import styled from 'styled-components';

export const InputsRange = styled.div`
	position: absolute;
	top: 340px;
	left: 81px;
`;
